export default __webpack_public_path__ + "static/media/pdfpreview.519b8f26.svg";